import { render, staticRenderFns } from "./AffiliateScope.vue?vue&type=template&id=ec67a56e"
import script from "./AffiliateScope.vue?vue&type=script&lang=js"
export * from "./AffiliateScope.vue?vue&type=script&lang=js"
import style0 from "./AffiliateScope.vue?vue&type=style&index=0&id=ec67a56e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports